import React from "react";

interface NavbarPCDropdownProps {
    children: React.ReactNode;
    content: NavbarPCDropdownProps['children'];
}

export function NavbarPCDropdown({ content, children }: NavbarPCDropdownProps ){
    return (
        <li className="nav-item dropdown">
            <span className="nav-link nav-link-pc dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {content}
            </span>
        
            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                {children}
            </ul>
        </li>
    );
}